/**
 * Created by Olga on 24.09.2026
 *
 */

const UnitSpeedUpButton = cleverapps.UI.Button.extend({
    ctor: function (options) {
        this.options = options;
        this.createTime = Date.now();

        const styles = cleverapps.styles.UnitSpeedUpButton;

        this._super({
            type: styles.type,
            text: options.isFree && Messages.get("FREE"),
            width: styles.width,
            height: styles.height,
            onClicked: this.speedUp.bind(this)
        });
        this.setAlignment(styles);

        if (!options.isFree) {
            this.updatePrice();
            this.priceInterval = cleverapps.timeouts.setInterval(this.updatePrice.bind(this), 1000);
        }
    },

    getTimeLeft: function () {
        return Math.max(0, this.options.timeLeft - (Date.now() - this.createTime));
    },

    speedUp: function () {
        const timeLeft = this.getTimeLeft();
        if (timeLeft <= 0) {
            return;
        }

        const price = Unit.CalcSpeedUPPrice(timeLeft);
        if (cleverapps.user.spendHard(this.options.eventName || cleverapps.EVENTS.SPENT.SPEED_UP, price)) {
            this.options.callback();
        }
    },

    updatePrice: function () {
        if (this.priceContent) {
            this.priceContent.removeFromParent();
            delete this.priceContent;
        }

        const price = Unit.CalcSpeedUPPrice(this.getTimeLeft());

        if (price <= 0) {
            this.hideForFree();
            return;
        }

        const content = this.priceContent = new TextWithIcon(`${price + TextWithIcon.ICONS_BY_NAME.rubies}^^`, {
            font: cleverapps.styles.FONTS.SPEED_UP_BUTTON_TEXT,
            icons: {
                "^^": bundles.merge.frames.unitinfo_skip_arrows_png
            }
        });
        content.setAlignment({ x: "center" }, { y: "center" });
        this.addChild(content);
    },

    hideForFree: function () {
        this.freeHidden = true;
        this.stopAllActions();
        this.setVisible(false);

        if (this.priceInterval) {
            cleverapps.timeouts.clearInterval(this.priceInterval);
            delete this.priceInterval;
        }
    },

    animateAppear: function (callback) {
        if (this.freeHidden) {
            callback && callback();
            return;
        }

        this.setScale(0.3);
        this.setVisible(false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.Show(),
            new cc.ScaleTo(0.2, 1.3).easing(cc.easeOut(2)),
            new cc.ScaleTo(0.15, 0.85).easing(cc.easeInOut(2)),
            new cc.ScaleTo(0.15, 1).easing(cc.easeInOut(2))
        )).setFinalize(callback);
    },

    onExit: function () {
        this._super();

        if (this.priceInterval) {
            cleverapps.timeouts.clearInterval(this.priceInterval);
            delete this.priceInterval;
        }
    }
});

cleverapps.styles.UnitSpeedUpButton = {
    type: cleverapps.styles.UI.Button.Images.field_button_blue,
    width: 140,
    height: 40,
    x: { align: "center" },
    y: { align: "bottom", dy: 10 }
};

cleverapps.overrideStyles(cleverapps.styles.FONTS, {
    SPEED_UP_BUTTON_TEXT: {
        name: "default",
        size: 30,
        stroke: cleverapps.styles.DECORATORS.DARK_BLUE_STROKE
    }
});
